import type { FaireProductEntity } from "../../entity_types/product";

export const starter_collection_77: FaireProductEntity = {
  token: "starter_collection_77",
  type: "product",
  name: "Classic Minis Gift Set",
  brandName: "Brightland",
  imageUrl:
    '"https://cdn.faire.com/fastly/f7bd910cba88d91d86bf5ff4790437d2c87a13f28b27c7f0c19f585cd455e607.jpeg?bg-color=FFFFFF&dpr=2&fit=crop&format=jpg&height=720&precrop=2297',
  priceDollars: 45,
  msrpDollars: 90,
  description: "Migrated starter collections product",
  tags: ["starter-collections"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "playground-data-migration",
  },
};
